// extracted by mini-css-extract-plugin
export default {"root":"sbkTHczitl","content":"s95xgP39TJ","description":"yAs5jZFODp"};